export class DQOIDispatchDisplaySettings {
    useCPRefData: boolean = false;
    forceReadOnly: boolean = false;

    showDispatchTab: boolean = true;
    showDispatchThirdPartyHistoryDialog: boolean = true;
    showInvoiceEstimateDialog: boolean = true;
    showCpCopyFieldText: boolean = true;
    showCpSearchTarget: boolean = true;
    showRefTracking: boolean = true;
    showWorkorderNotes: boolean = true;
    showDispatchAssignments: boolean = true;
    showDispatchAssignmentHistory: boolean = true;
    showDispatchLabor: boolean = true;
    showWorkorderAttachments: boolean = true;
    showDispatchHistory: boolean = true;
    showDispatchPartsRequested: boolean = true;
    showDispatchPartsOrdered: boolean = true;
    showDispatchParts: boolean = true;
    showDispatchCustomerSuppliedParts: boolean = true;
    showDispatchEquipSvcd: boolean = true;
    showDispatchStatusHistory: boolean = true;
    showDispatchAssets: boolean = true;
    showDispatchVendorCredits: boolean = true;
    showKudosOpportunity: boolean = true;
    showDispatchCallback: boolean = true;
    showConfirmDialog: boolean = true;
    showMessageInfoDialog: boolean = true;
    showChangeStatusDialog: boolean = true;
    showCpWindow: boolean = true;
    showDqoiInWindow: boolean = true;
    showScheduleDispatches: boolean = true;
    showInvoiceChecklist: boolean = true;
    showCallbackRfbCheck: boolean = true;

    constructor(data: Partial<DQOIDispatchDisplaySettings> = {}) {
        Object.assign(this, data);
    }
}

export class DQOIOrderDisplaySettings {
    useCPRefData: boolean = false;
    forceReadOnly: boolean = false;

    showOrderTab: boolean = true;
    showOrderNotes: boolean = true;
    showSupplierInfo: boolean = true;
    showSubpoOrderinfo: boolean = true;
    showGeographyInfo: boolean = true;
    showOrderLineitems: boolean = true;
    showOrderAttachments: boolean = true;
    showStatusHistory: boolean = true;
    showOrderErrors: boolean = true;
    showReceiving: boolean = true;
    showOrderBills: boolean = true;
    showVendorCredits: boolean = true;
    showVendorReturns: boolean = true;

    constructor(data: Partial<DQOIOrderDisplaySettings> = {}) {
        Object.assign(this, data);
    }
}

export class DQOIQuoteDisplaySettings {
    useCPRefData: boolean = false;
    forceReadOnly: boolean = false;

    showQuoteTab: boolean = true;
    showQuoteTemplateSave: boolean = true;
    showImportBid: boolean = true;
    showQuoteLineitems: boolean = true;
    showQuoteEquipment: boolean = true;
    showQuoteNotes: boolean = true;
    showQuoteAttachments: boolean = true;
    showTaxCode: boolean = true;
    showInvoicePicker: boolean = true;

    constructor(data: Partial<DQOIQuoteDisplaySettings> = {}) {
        Object.assign(this, data);
    }
}

export class DQOIInvoiceDisplaySettings {
    useCPRefData: boolean = false;
    forceReadOnly: boolean = false;

    showInvoiceTab: boolean = true;
    showInvoiceNotes: boolean = true;
    showInvoiceLineitems: boolean = true;
    showInvoiceDisputeCm: boolean = true;
    showCollectionNotes: boolean = true;
    showInvoiceAttachments: boolean = true;
    showInvoiceEquipment: boolean = true;
    showScheduleInvoices: boolean = true;
    showInvoicePayments: boolean = true;
    showQuotePicker: boolean = true;
    showInvoiceCopytoNew: boolean = true;
    showInvoiceCmCr: boolean = true;
    showCreditMemoCorr: boolean = true;

    constructor(data: Partial<DQOIInvoiceDisplaySettings> = {}) {
        Object.assign(this, data);
    }
}

export class DQOIDisplaySettings {
    useCPRefData: boolean = false;
    forceReadOnly: boolean = false;

    dispatch: DQOIDispatchDisplaySettings;
    order: DQOIOrderDisplaySettings;
    quote: DQOIQuoteDisplaySettings;
    invoice: DQOIInvoiceDisplaySettings;

    constructor(data: Partial<DQOIDisplaySettings> = {}) {
        this.useCPRefData = data.useCPRefData ?? false;
        this.forceReadOnly = data.forceReadOnly ?? false;

        this.dispatch = new DQOIDispatchDisplaySettings({
            ...data.dispatch,
            useCPRefData: this.useCPRefData,
            forceReadOnly: this.forceReadOnly
        });
        this.order = new DQOIOrderDisplaySettings({
            ...data.order,
            useCPRefData: this.useCPRefData,
            forceReadOnly: this.forceReadOnly
        });
        this.quote = new DQOIQuoteDisplaySettings({
            ...data.quote,
            useCPRefData: this.useCPRefData,
            forceReadOnly: this.forceReadOnly
        });
        this.invoice = new DQOIInvoiceDisplaySettings({
            ...data.invoice,
            useCPRefData: this.useCPRefData,
            forceReadOnly: this.forceReadOnly
        });
    }
}
